<template>
  <div id="Setting">
    <div class="pt-1">
      <div class="m-2 text-left">
        <van-cell to="/UserInfo" class="border-radius">
          <!-- :title="RealName" :label="UserName" to="/UserInfo" -->
          <template slot="icon">
            <img class="m-2" src="../assets/logo.png" width="50" height="50" />
          </template>
          <template slot="title">
            <div class="mt-2 ml-2">
              <span>{{ RealName }}</span>
              <small class="ml-2 color-yellow" v-if="!(getWork() && getAddr())">
                {{
                  getAuth().UserType == 1 || getAuth().RoleID == 23
                    ? "机构管理员"
                    : "工作人员"
                }}
              </small>
            </div>
          </template>
          <template slot="label">
            <div class="ml-2">登陆账号 [{{ UserName }}]</div>
          </template>
          <template slot="default">
            <!-- <small class="color-red" @click="Exit">退出登录</small> -->
          </template>
          <template slot="right-icon">
            <i class="mt-4 color-gray fa fa-chevron-right"></i>
          </template>
        </van-cell>
      </div>
    </div>

    <div class="m-2" v-if="getAuth().RoleID == 23">
      <van-button
        plain
        class="border-0"
        type="mt-4 w-100 color-gray"
        to="/OrganManage"
        >机构工作人员管理</van-button
      >
    </div>
    <div
      class="m-2"
      v-if="getAuth().RoleID == 23 && WorkId && getAuth().OrganType == 2"
    >
      <van-button
        plain
        class="border-0"
        type="mt-4 w-100 color-gray"
        to="/UserPasswordManage"
        >考试人员密码管理</van-button
      >
    </div>

    <div class="m-2">
      <van-cell v-if="getWork() && getAddr()" class="border-radius">
        <template slot="default">
          <div>
            <small>
              正在管理考试
              <b>{{ getWork().WorkName }}</b> </small
            >,
            <small>
              考试中参与考试机构
              <b>{{ getAddr().OrganName }}</b> </small
            >,
            <small>
              考试所属工作岗位
              <b>{{ getAddr().RoleName }}</b> </small
            >,
            <small>
              工作管辖范围
              <b>{{ getAddr().RangeName }}</b> </small
            >,
            <small>请及时上报工作任务.</small>
          </div>
        </template>
      </van-cell>
    </div>
    <van-cell-group class="m-2 text-left">
      <van-cell title="性别" :value="UserSex">
        <template slot="icon">
          <i class="fa fa-fw fa-intersex mt-1 mr-1 color-yellow"></i>
        </template>
      </van-cell>
      <van-cell title="座机号" :value="Tel || '未填写'" icon="phone-circle-o">
        <template slot="icon">
          <i class="fa fa-fw fa-tty mt-1 mr-1 color-green"></i>
        </template>
      </van-cell>
      <van-cell title="手机号" :value="Phone || '未填写'" icon="phone-o">
        <template slot="icon">
          <i class="fa fa-fw fa-phone mt-1 mr-1 color-blue"></i>
        </template>
      </van-cell>
      <van-cell title="机构" icon="location-o">
        <template slot="icon">
          <i class="fa fa-fw fa-map-pin mt-1 mr-1 color-purple"></i>
        </template>
        <template slot="default">
          <div
            class="text-overflow"
            @click="$dialog.alert({ message: OrganName })"
          >
            {{ OrganName }}
          </div>
        </template>
      </van-cell>
      <!-- <template v-else>
        <van-cell title="机构" icon="location-o">
          <template slot="icon">
            <i class="fa fa-fw fa-map-pin mt-1 mr-1 color-purple"></i>
          </template>
          <template slot="default">
            <div
              class="text-overflow"
              @click="$dialog.alert({ message: OrganName })"
            >
              {{ OrganName }}
            </div>
          </template>
        </van-cell>
      </template>-->

      <!-- <van-cell
        title="银行卡信息"
        to="/BankCard"
        v-if="getVer().BankNoFlg == 1"
        is-link
      >
        <template slot="icon">
          <i class="fa fa-fw fa-credit-card mt-1 mr-1 color-green"></i>
        </template>
      </van-cell> -->

      <!-- <van-cell
        title="紧急联系人信息"
        to="/UrgentContact"
        v-if="getVer().UrgentContactFlg == 1"
        icon="manager-o"
        is-link
      >
        <template slot="icon">
          <i class="fa fa-fw fa-user-o mt-1 mr-1 color-red"></i>
        </template>
      </van-cell> -->

      <van-cell title="修改登陆密码" to="/ChangePwd" icon="closed-eye " is-link>
        <template slot="icon">
          <i class="fa fa-fw fa-unlock-alt mt-1 mr-1"></i>
        </template>
      </van-cell>
      <van-cell title="投诉建议" to="/AdviceList" icon="chat-o" is-link>
        <template slot="icon"> </template>
      </van-cell>
    </van-cell-group>

    <van-cell-group class="text-left m-2">
      <van-cell
        title="软件版本"
        to="/Update"
        icon="upgrade"
        :value="this.Ver()"
        v-if="showUpdateBtn"
        is-link
      />
    </van-cell-group>

    <!-- <div class="mt-0">
      <div id="container"></div>
    </div>-->

    <div class="m-2">
      <van-button
        plain
        class="border-0"
        type="mt-4 w-100 color-gray"
        @click="Exit"
        >退出登录</van-button
      >
      <div class="color-gray copyrightDiv">{{ copyright }}    </br>
        {{copyright1}}</div>
    </div>
   
    <div id="main" style="width: 300px; height: 200px"></div>
  </div>
</template>

<script>
export default {
  name: "Setting",
  data () {
    return {
      RealName: "姓名",
      UserName: "用户",
      OpenID: "OpenID",
      UserSex: 0,
      Tel: "--",
      Phone: "--",
      OpeningBank: "--",
      WorkUnit: "--",
      UrgentContact: "--",
      OrganName: "--",
      showUpdateBtn: false,
      WorkId: "",
      copyright: "Copyright © 2025山东省人事考试中心",
      copyright1: "鲁ICP备2021017574号-3X",
    };
  },
  methods: {
    Exit () {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定注销当前用户登录信息 ?"
        })
        .then(() => {
          // on confirm
          this.$router.push({ name: "LogOut" });
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  created () {
    if (this.getWork()) {
      this.WorkId = this.getWork().WorkID
    }
    this.apiUserGet(this, res => {
      // eslint-disable-next-line
      //console.log("Auth", res);
      this.RealName = res.data.RealName;
      this.UserName = res.data.UserName;
      this.OpenID = res.data.OpenID;
      switch (res.data.UserSex) {
        case 1:
          this.UserSex = "男";
          break;
        case 2:
          this.UserSex = "女";
          break;
        default:
          this.UserSex = "--";
          break;
      }
      this.Tel = res.data.Tel;
      this.Phone = res.data.Phone;
      this.OrganName = res.data.OrganName;
      this.UrgentContact = res.data.UrgentContact;
      this.OpeningBank = res.data.OpeningBank;
    });
    //判断当前运行是不是移动端,是移动端的话允许访问更新页
    if (window.plus) {
      // eslint-disable-next-line
      if (plus) {
        this.showUpdateBtn = true;
      }
    }
  },
  mounted () {
    /* var mapAddress = this.getAuth().MapCoord.split(",");
    var map = new AMap.Map("container", {
      mapStyle: "amap://styles/whitesmoke", //设置地图的显示样式
      zoom: 11, // 缩放比例
      pitch: 0, // 地图俯仰角度，有效范围 0 度- 83 度
      viewMode: "3D", // 地图模式
      // center: [mapAddress[0], mapAddress[1]] //设置地图中心点坐标
      // layers: [new AMap.TileLayer.Satellite()],  //设置图层,可设置成包含一个或多个图层的数组
      // lang:'zh_cn',  //设置地图语言类型
    }); */
  }
};
</script>

<style scoped>
#Setting {
  background: #efefef;
  min-height: 700px;
}
ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 0;
}
.cust-active button {
  border: 1px solid rgb(0, 155, 255);
}
.cust-btn {
  width: 96%;
  margin: 2%;
}
#container {
  width: 100%;
  height: 180px;
}
.copyrightDiv {
  margin-top: 6%;
  width: 100%;
  text-align: center;
  font-size: 0.75rem;
}
</style>
